var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScoreLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 48,
    viewBox: "0 0 28 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.34286,
    height: 17.8286,
    rx: 1.67143,
    transform: "matrix(-0.588648 0.80839 0.80839 0.588648 2.00464 3.34283)",
    fill: "#6CE2E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.34286,
    height: 8.24064,
    rx: 1.67143,
    transform: "matrix(-0.909493 0.415719 0.415719 0.909493 24.2117 0)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.34286,
    height: 11.8515,
    rx: 1.67143,
    transform: "matrix(0.049507 0.998774 0.998774 -0.049507 0 22.2014)",
    fill: "#1D3C8A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.34286,
    height: 9.10028,
    rx: 1.67143,
    transform: "matrix(0.510817 0.859689 0.859689 -0.510817 1.95728 39.6346)",
    fill: "#FB7B55"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.34286,
    height: 8.42236,
    rx: 1.67143,
    transform: "matrix(0.808691 0.588234 0.588234 -0.808691 18.4355 45.8111)",
    fill: "#3FA2F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreLeft);
export default __webpack_public_path__ + "static/media/score-left.442ded71b5be6eda7c6e2c5836d1c41a.svg";
export { ForwardRef as ReactComponent };